import { h } from 'preact';
import BaseComponent from './BaseComponent';
import { update } from 'Emitter';
import { UI } from 'StateEvents';
import { reportEvent } from 'Services/Reporting/Reporters';
import * as ResourceTypes from 'Services/Reporting/ResourceTypes';
import * as is from 'Misc/is';
import { unique } from 'Misc/collections';

export default class Icons extends BaseComponent {
  constructor() {
    super();
  }

  onClick(icon) {
    if(icon.tracking.clickthrough) {
      window.open(icon.tracking.clickthrough, '_blank');
    }
    if(icon.tracking.clicktracking) {
      reportEvent({
        src: icon.tracking.clicktracking,
        format: ResourceTypes.IMAGE_RESOURCE
      });
    }
  }

  render(props) {
    if(props.icons && props.icons.length) {
      return (
        <ul class="icons">
          { this.renderIcons(props.icons) }
        </ul>
      )
    }
    
    return null;
  }

  renderIcons(icons) {
    let normalized = 
          icons
            .reduce(this.removeDuplicatePrograms.bind(this), [])
            .map(this.normalizePosition.bind(this)),
        posOffsets = normalized.reduce(this.findOverlaps.bind(this), { left: 0, top: 0, right: 0, bottom: 0, history: [] });

    return (
      normalized
        .map(this.applyIconStyles.bind(this, posOffsets.history))
        .map(this.getIconContainer.bind(this))
    );
  }

  normalizePosition(icon) {
    icon.style = {};

    if(is.num(icon.xPosition)) {
      icon.left = icon.xPosition;
    } else if(is.str(icon.xPosition) && icon.xPosition === 'left') {
      icon.left = 0;
    } else if(is.str(icon.xPosition) && icon.xPosition === 'right') {
      icon.right = 0;
    } else if(!is.def(icon.xPosition)) {
      style.left = 0;
    }

    if(is.num(icon.yPosition)) {
      icon.top = icon.yPosition;
    } else if(is.str(icon.yPosition) && icon.yPosition === 'top') {
      icon.top = 0;
    } else if(is.str(icon.yPosition) && icon.yPosition === 'bottom') {
      icon.bottom = 0;
    } else if(!is.def(icon.yPosition)) {
      style.top = 0;
    }

    return icon;
  }

  findOverlaps(overlaps, icon) {
    overlaps.history.push(Object.assign({}, {}, overlaps));
    overlaps.left   += is.def(icon.left)   && is.def(icon.width)  ? icon.width  : 0;
    overlaps.right  += is.def(icon.right)  && is.def(icon.width)  ? icon.width  : 0;  

    return overlaps;
  }

  getIconContainer(icon) {
    let tag;

    switch(icon.src.type) {
      case 'StaticResource':
        tag = <img src={ icon.src.content } width={ icon.width } height={ icon.height } onClick={ this.onClick.bind(this, icon) } style={ icon.style }/>;
        break;
      case 'IFrameResource':
        tag = <iframe src={ icon.src.content } width={ icon.width } height={ icon.height } scrolling="no" frameborder="0" style={ icon.style }/>;
        break;
      case 'HTMLResource':
        tag = <div style={ icon.style } dangerouslySetInnerHTML={ { __html: icon.src.content } }></div>;
        break;
    }

    return <li>{ tag }</li>;
  }

  applyIconStyles(offsets, icon, index) {
    icon.style.position = 'absolute';
    icon.style.width    = `${icon.width}px`;
    icon.style.height   = `${icon.height}px`;
    icon.style.display  = this.getDisplayStyle(icon);

    ['left', 'top', 'right', 'bottom']
      .forEach(prop => {
        if(is.def(icon[prop])) {
          icon.style[prop] = icon[prop];
          icon.style[prop] += offsets[index][prop];
          icon.style[prop] = `${icon.style[prop]}px`;
        }
      });

    return icon;
  }

  getDisplayStyle(icon = {}) {
    return this.canShow(icon, this.props.media.current_time) ? 'block' : 'none';
  }

  canShow(icon, currentTime) {
    const timing = this.getIconDisplayTiming(icon);
    return timing.start <= currentTime && timing.end >= currentTime;
  }

  getIconDisplayTiming(icon = {}) {
    const timing = {
      start: 0,
      end: Infinity
    };

    if(icon.duration > 0) {
      timing.start = icon.offset;
      timing.end = icon.offset + icon.duration;
    }

    return timing;
  }

  removeDuplicatePrograms(selected, icon) {
    const displayedPrograms = selected.map( s => s.program );
    if(displayedPrograms.indexOf(icon.program) === -1) {
      selected.push(icon);
    }

    return selected;
  }
}


// WEBPACK FOOTER //
// ./src/Display/Components/Icons.js